import { createStore } from "jotai";

export const authStore = createStore();
